import script from "./commission-calculator.vue?vue&type=script&setup=true&lang=js"
export * from "./commission-calculator.vue?vue&type=script&setup=true&lang=js"

import "./commission-calculator.vue?vue&type=style&index=0&id=275d2233&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-275d2233"]])

export default __exports__